/* --- Banner --- */

	function bannerSetup(){
		const banner = document.querySelector('.banner');
		banner.classList.add('is-hidden'); // and hide it

		// Show the header if mouse enter
		const bannerTeaser = banner.querySelector('.banner-teaser');
		bannerTeaser.addEventListener('mouseenter', function() {
			if (banner.classList.contains('is-hidden')) {
				banner.classList.remove('is-hidden');
				banner.classList.add('button-trigger');
			}
		});
	}

	// Function to show or hide the banner
	const bannerScroll = throttle(function() {
		const banner = document.querySelector('.banner');

		// Get the height of the header
		const past = (document.body.scrollTop || document.documentElement.scrollTop) > document.querySelector('.header').offsetHeight;

		// If the header has been trigger by the teaser
		if (banner.classList.contains('button-trigger')) {
			if (past) { // If we are below the header
				banner.classList.remove('button-trigger'); // Remove the trigger
				banner.classList.remove('is-hidden'); // Show the banner
			}
		} else { // The teaser did nothing
			if (past) { // If we are below the header
				banner.classList.remove('is-hidden'); // Show the banner
			} else { // We are in the header
				banner.classList.add('is-hidden'); // Hide the banner
			}
		}
	}, 250);

/* --- End - Banner --- */
